@if (href(); as href) {
  <a
    [href]="href"
    target="_blank"
    rel="noopener noreferrer"
    [class]="classes().link">
    <ng-container [ngTemplateOutlet]="content" />
  </a>
} @else {
  <a
    [routerLink]="link()"
    [attr.aria-current]="isActive() ? 'page' : null"
    [class]="classes().link">
    <ng-container [ngTemplateOutlet]="content" />
  </a>
}

<ng-template #content>
  @if (isActive() && indicator()) {
    <span [class]="classes().indicator" aria-hidden="true"></span>
  }
  @if (icon(); as icon) {
    <vx-icon [name]="icon" size="lg" [class]="classes().icon" />
  }
  <span [class]="classes().label"><ng-content></ng-content></span>
  @if (hasBadge()) {
    <span [class]="classes().badge">{{ badge() }}</span>
    @if (compact()) {
      <span [class]="classes().dot" aria-hidden="true"></span>
    }
  }
</ng-template>
